import { z } from "zod";

import { config } from "./config";

export const MeetingsTableFiltersSchema = z.object({
	status: z.array(z.enum(config.statusOptions)).optional(),
	privateNotes: z.enum(config.privateNotesOptions).optional(),
	meetingDateStart: z.date().optional(),
	meetingDateEnd: z.date().optional(),
});

export type MeetingsTableFilters = z.infer<typeof MeetingsTableFiltersSchema>;
